import store from "@/store/index";
import Select from "@/components/Select.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
export const mix = {
  components: { Select },
  directives: {
    "click-outside": {
      //@ts-ignore
      bind: function(el, binding, vnode) {
        //@ts-ignore
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.arg] = false;
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  methods: {
    selectHours() {
      let response = [];
      for (let i = 0; i < 24; i++) {
        let hour = i < 10 ? "0" + i : i;
        response.push({
          name: hour + ":00",
          value: hour + ":00:00",
        });
      }
      return response;
    },
    logout() {},
    ...mapActions(["array_to_select"]),
  },
  computed: {
    ...mapState({
      _global: "global",
    }),
  },
  created() {},
};
